import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import {
  CreateDriverTypeModel,
  DeleteDriverTypeModel,
  SearchDriverTypeModel,
} from '../../../models/driver-type.model'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'

@Injectable({
  providedIn: 'root',
})
export class OccurrenceOsService {
  private baseUrl = environment.baseUrl
  private resource: string = 'OcorrenciaOrdemServico'

  constructor(private httpClient: HttpClient) { }

  public createOccurrenceServiceOrder(
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editOccurrenceServiceOrder(
    model: any,
    // model: EditDriverTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deleteOccurrenceServiceOrder(
    id: string,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete/${id}`,
      id,
    )
  }

  public listPagedOccurrenceServiceOrder(
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listOccurrenceServiceOrder(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public getOccurrencebyIdServiceOrder(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedOccurrenceServiceOrder(
    page: number,
    rows: number = 15,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated/ordemServico?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
